// Shared email validation for the renewal dialogs.
//
// The domain must be dot-separated, so pasted subject lines, bare words and
// single-label hosts ("localhost") are all rejected rather than reaching SendGrid.
export const EMAIL_PATTERN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export function isValidEmail(value: string): boolean {
  return !!value && EMAIL_PATTERN.test(value.trim());
}

// Returns the entries that are not valid addresses, so the UI can name them.
//
// ';' is the only separator accepted on purpose: the API splits CCList and emailTos
// on ';' alone (OnlineRenewalsController.sendEmail), so a comma-separated list would
// travel onward as one malformed address. Flagging it here makes the user fix it.
export function getInvalidEmails(value: string): string[] {
  if (!value) {
    return [];
  }

  return value
    .split(';')
    .map(email => email.trim())
    .filter(email => email != '')
    .filter(email => !EMAIL_PATTERN.test(email));
}
